import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  getTransactionLogs,
  reset
} from "redux/admin/transaction-logs/transactionLogsSlice";
import Pagination from "components/Pagination";
import TransactionLogs from "components/Panel/Admin/TransactionLogs";
import { toast } from "react-toastify";

const TransactionLogsContainer = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const {
    transactionLogsList,
    isLoading,
    isError,
    isSuccess,
    message
  } = useSelector((state) => state.adminTransactionLogs);

  const { data, page, pages, per_page, total } = transactionLogsList;

  // Parse URL parameters and set initial filters
  const getInitialFilters = () => {
    return {
      page: parseInt(searchParams.get('page')) || 1,
      per_page: parseInt(searchParams.get('per_page')) || 30,
      user_type: searchParams.get('user_type') || "",
      txtype: searchParams.get('txtype') || "",
      amount_min: searchParams.get('amount_min') || "",
      amount_max: searchParams.get('amount_max') || "",
      search: searchParams.get('search') || "",
      user_id: searchParams.get('user_id') || "",
      order_id: searchParams.get('order_id') || "",
      payment_id: searchParams.get('payment_id') || "",
    };
  };

  const [filters, setFilters] = useState(getInitialFilters);

  // Utility function to clean filters
  const cleanFilters = (filtersToClean) => {
    return Object.fromEntries(
      Object.entries(filtersToClean).filter(([_, value]) => {
        return value !== "" && value !== null && value !== undefined;
      }).map(([key, value]) => {
        // Convert numeric fields to numbers if they're valid
        if ((key === 'amount_min' || key === 'amount_max' || key === 'page' || key === 'per_page') && value !== "") {
          const numValue = parseFloat(value);
          return [key, isNaN(numValue) ? value : numValue];
        }
        return [key, value];
      })
    );
  };

  useEffect(() => {
    // Update filters when URL parameters change
    const newFilters = getInitialFilters();
    setFilters(newFilters);
    dispatch(getTransactionLogs(cleanFilters(newFilters)));
  }, [dispatch, searchParams]);

  useEffect(() => {
    if (isError) {
      toast.error(message || "İşlem logları alınamadı!");
      dispatch(reset());
    }
  }, [dispatch, isError, message]);

  const handlePageChange = (newPage) => {
    const newFilters = { ...filters, page: newPage };
    setFilters(newFilters);
    dispatch(getTransactionLogs(cleanFilters(newFilters)));
  };

  const handleFilterChange = (newFilters) => {
    const updatedFilters = {
      ...newFilters,
      page: 1, // Reset to first page when filters change
      per_page: filters.per_page
    };
    
    setFilters(updatedFilters);
    dispatch(getTransactionLogs(cleanFilters(updatedFilters)));
  };

  if (isLoading) {
    return (
      <div className="bg-black min-h-screen p-4 flex items-center justify-center">
        <div className="text-white-100">İşlem logları yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="bg-black min-h-screen p-4">
      <div className="mb-4">
        <h2 className="text-xl font-semibold text-white-100 mb-2">
          İşlem Logları
        </h2>
        {total > 0 && (
          <p className="text-gray-400 text-sm">
            {total} işlem logundan {data?.length || 0} tanesi gösteriliyor
          </p>
        )}
      </div>

      <TransactionLogs 
        data={data} 
        onFilterChange={handleFilterChange}
        filters={filters}
      />

      {pages > 1 && (
        <Pagination
          currentPage={page || 1}
          totalPages={pages || 1}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default TransactionLogsContainer;